/**
 * Bridge between Horizon's <predictive-search-component> and Nosto's autocomplete.
 *
 * Horizon's predictive-search-component:
 *   - Opens via the search-modal dialog
 *   - Listens to `input` events on `ref="searchInput"`
 *   - Calls a `/search` method (declared on:input in search-modal.liquid)
 *
 * Approach: monkey-patch the search method to neutralise the predictive
 * fetch and rendering. The dialog/focus/escape behaviours stay intact —
 * we just stop the native predictive results from populating. The Preact
 * `AutocompleteInjected` component then owns the dropdown content via a
 * portal into `[data-nosto-autocomplete-dropdown]`.
 *
 * Loaded only when `settings.nosto_enabled === true`.
 */
(function () {
  if (typeof customElements === 'undefined') return;

  customElements
    .whenDefined('predictive-search-component')
    .then(() => {
      const PSComponent = customElements.get('predictive-search-component');
      if (!PSComponent || !PSComponent.prototype) return;

      // Methods to neutralise. Names taken from Horizon's predictive-search.js.
      // We swallow the call entirely so the native results never populate.
      const methodsToStub = ['search', 'fetchPredictiveSearchResults', 'renderSearchResults'];

      for (const fn of methodsToStub) {
        if (typeof PSComponent.prototype[fn] !== 'function') continue;
        PSComponent.prototype[fn] = function () {
          // Hide the native results container so Nosto owns the visual real estate.
          const nativeResults = this.querySelector('[data-search-results]') ||
                                (this.refs && this.refs.predictiveSearchResults);
          if (nativeResults) nativeResults.style.display = 'none';
          // Swallow the call. We deliberately do NOT call the original —
          // Nosto's Preact app handles all search behaviour from now on.
          return undefined;
        };
      }
    })
    .catch(() => {
      // whenDefined rejects only on invalid element names — never happens here.
    });
})();
